import type { DomainCrawlerResponse } from '@prerender/diagnostics-api';
import { Table } from 'react-bootstrap';

import { formatDropAsChange, formatRequestCountOrAbsent } from './crawlerEvidenceFigures';
import { crawlerLabel } from './crawlerLabels';
import CrawlerStandingCell from './CrawlerStandingCell';
import { formatInstantOrAbsent } from './formatDetectedAt';

type DomainCrawlerTableProps = {
  domain: string;
  crawlers: readonly DomainCrawlerResponse[];
};

type CrawlerColumn = {
  label: string;
  numeric?: boolean;
};

const COLUMNS: readonly CrawlerColumn[] = [
  { label: 'Crawler' },
  { label: 'Last 7 days', numeric: true },
  { label: 'Usual week', numeric: true },
  { label: 'Change', numeric: true },
  { label: 'Last request' },
  { label: 'Severity' },
  { label: 'First detected' },
];

function DomainCrawlerTable({ domain, crawlers }: DomainCrawlerTableProps) {
  return (
    <Table
      className="diagnostics-evidence-table diagnostics-crawler-evidence-table diagnostics-domain-crawler-table"
      aria-label={`Crawler figures on ${domain}`}
    >
      <thead>
        <tr>
          {COLUMNS.map(({ label, numeric }) => (
            <th key={label} scope="col" className={numeric ? 'diagnostics-cell-numeric' : undefined}>
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {crawlers.map((row) => (
          <tr key={row.crawler} className={row.noLongerAffected ? 'diagnostics-evidence-recovered' : undefined}>
            <th scope="row">{crawlerLabel(row.crawler)}</th>
            <td className="diagnostics-cell-numeric">{formatRequestCountOrAbsent(row.currentRequests)}</td>
            <td className="diagnostics-cell-numeric">{formatRequestCountOrAbsent(row.usualWeekRequests)}</td>
            <td className="diagnostics-cell-numeric">
              <strong>{formatDropAsChange(row.metricValue)}</strong>
            </td>
            <td className="diagnostics-cell-muted">{formatInstantOrAbsent(row.lastRequestAt)}</td>
            <CrawlerStandingCell severity={row.severity} noLongerAffected={row.noLongerAffected} />
            <td className="diagnostics-cell-muted">{formatInstantOrAbsent(row.firstDetectedAt)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default DomainCrawlerTable;
